import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./SocialPostTypeContent.scss";
import { visage2SocialPostTypes } from "src/social-feed/types";
import { SpintrTypes } from "src/typings";
import { CaptionBody, CaptionBolder, LargeBody, MediumBody, SmallBody, SmallBodyBolder } from "src/components/Text";
import { SpintrUser, UnstyledButton } from "src/ui";
import { localize } from "src/l10n";
import { UsersListPopup } from "src/users/views";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { ReactSVG } from 'react-svg';
import SocialPostTypeContentInput from "./SocialPostTypeContentInput";
import SocialPostTypeContentConfetti from "./SocialPostTypeContentConfetti";

interface IProps {
    post: any;
    editMode?: boolean;
    onUpdate?: any;
    goToEditUsers?: any;
}

const UserLink = ({id, children, editMode}) => {
    if (editMode) {
        return (
            <div>
                {children}
            </div>
        )
    }

    return (
        <Link to={"/profile/" + id}>
            {children}
        </Link>
    )
}

const SocialPostTypeContentKudos = (props: IProps) => {
    const [hideLikersPopup, setHideLikersPopup] = useState(true);

    const users : Spintr.IUser[] = props.post.targetUsers || [];

    // The face, the name and the unit when the user has one
    const renderUser = (user: any) => (
        <div className="user" key={user.id}>
            <UserLink id={user.id} editMode={props.editMode}>
                <SpintrUser hideText imageUrl={user.image} name={user.name} personalName={true} size={40} />
            </UserLink>
            <div className="user-text">
                <UserLink id={user.id} editMode={props.editMode}>
                    <MediumBody as="span" weight="semiBold" color="contentDark">{user.name}</MediumBody>
                </UserLink>
                {!!user.departmentName && (
                    <CaptionBody as="span" color="contentNormal">{user.departmentName}</CaptionBody>
                )}
            </div>
        </div>
    );

    // On the theme: the confetti, and a white plate with the badge, the recipients and the
    // text in dark (B32, AMR-500), in the feed and in the composer
    return (
        <div className={"user-count-" + (users.length < 3 ? users.length : "many")}>
            {
                props.post.displayDecorations && (
                    <SocialPostTypeContentConfetti />
                )
            }
            <div className="kudos-plate">
                <div className="kudos-badge">
                    <Visage2Icon icon="star" size="small" color="dark-grey" />
                    <CaptionBolder as="span" weight="semiBold" color="contentDark">{localize("KUDOS")}</CaptionBolder>
                </div>
                {users.length > 0 && users.length < 3 && (
                    <div className="users">
                        {users.map(renderUser)}
                    </div>
                )}
                {users.length > 2 && (
                    <div className="users">
                        <UnstyledButton
                            disabled={props.editMode}
                            onClick={() => {
                                setHideLikersPopup(false);
                            }}>
                            <div className="images">
                                {users.map((user: any, index: number) => {
                                    return (
                                        <SpintrUser key={index} hideText imageUrl={user.image} name={user.name} personalName={true} />
                                    )
                                })}
                            </div>
                            <SmallBodyBolder as="span" color="contentDark">
                                {users[0].name + " " + localize("Och_small") + " " + (users.length - 1) + " " + localize("till_more")}
                            </SmallBodyBolder>
                        </UnstyledButton>
                    </div>
                )}
                {users.length === 0 && props.editMode && (
                    <div className="add-button-big">
                        <UnstyledButton
                            onClick={() => {
                                props.goToEditUsers();
                            }}>
                            <Visage2Icon icon="add" color="dark-grey" size="small" />
                            <SmallBody as="span" color="contentDark">{localize("LaggTill")}</SmallBody>
                        </UnstyledButton>
                    </div>
                )}
                {(props.editMode || !!props.post.comment) && (
                    <div className="content-wrapper">
                        {
                            !props.editMode && (
                                <LargeBody as="p" weight="regular" color="contentDark">{props.post.comment}</LargeBody>
                            )
                        }
                        {
                            props.editMode && (
                                <SocialPostTypeContentInput
                                    big
                                    value={props.post.comment || ""}
                                    placeholder={localize("SkrivNagot")}
                                    onChange={(text) => {
                                        props.onUpdate({
                                            ...props.post,
                                            comment: text
                                        })
                                    }} />
                            )
                        }
                    </div>
                )}
                {users.length > 0 && props.editMode && (
                    <div className="add-button-small">
                        <UnstyledButton
                            onClick={() => {
                                props.goToEditUsers();
                            }}
                            title={localize("CHAT_ADD_PEOPLE")}>
                            <Visage2Icon icon="edit" color="dark-grey" />
                        </UnstyledButton>
                    </div>
                )}
            </div>
            <UsersListPopup
                users={users}
                title={props.post.comment || localize("THANK_YOU")}
                popupIsHidden={hideLikersPopup}
                closePopup={() => {
                    setHideLikersPopup(true);
                }} />
        </div>
    )
}

export default SocialPostTypeContentKudos;
